if (!customElements.get('testimonials-slider')) {
  
  customElements.define(
    
    'testimonials-slider',
    
    class TestimonialsSlider extends HTMLElement {
      
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        if (this.getSlideItems.length > 1) {
          PCOtheme.Motion.inView(this, this.initSwiper.bind(this), { margin: '200px 0px 200px 0px' });
        }
      }
      
      isAutoplayEnabled() {
        if (Shopify.designMode) return false;
        return this.hasAttribute('autoplay');
      }
      
      getAutoplaySpeed() {
        return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
      }
      
      get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.swiperWrapper.children));
      }
      
      initSwiper() {
        
        const slider = this.querySelector('.swiper');
        
        if (!slider) return;
        
        const swiper = new PCOtheme.Swiper.Swiper(slider, {
          modules: [
            PCOtheme.Swiper.Pagination,
            PCOtheme.Swiper.Autoplay
          ],
          pagination: PCOtheme.Swiper.PaginationDefault,
          loop: true,
          speed: 700,
          spaceBetween: 0,
          autoplay: this.isAutoplayEnabled() ? { delay: this.getAutoplaySpeed(), pauseOnMouseEnter: true } : false
        });
        
        // handle theme editor
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            swiper.slideTo(this.getSlideItems.indexOf(event.target));
          });
        }
      }
    }
  );
}